import React from 'react';
import { motion } from 'framer-motion';
import { bookInfoRo } from '../../../data/bookDataRo';
import { FiExternalLink, FiShoppingCart } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const AuthorLinksRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 md:grid-cols-2 gap-8"
      >
        <div className="bg-brand-dark border border-white/5 rounded-2xl p-8">
          <h3 className="text-white font-display font-bold text-xl mb-6 flex items-center gap-3">
            <SafeIcon icon={FiExternalLink} className="text-brand-accent" /> Site-ul Autorului
          </h3>
          <div className="space-y-3">
            <a href={bookInfoRo.links.website.ro} target="_blank" rel="noreferrer"
              className="flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-xl border border-white/5 transition-colors group">
              <span className="text-white font-medium">Română (RO)</span>
              <SafeIcon icon={FiExternalLink} className="text-gray-500 group-hover:text-brand-accent transition-colors" />
            </a>
            <a href={bookInfoRo.links.website.en} target="_blank" rel="noreferrer"
              className="flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-xl border border-white/5 transition-colors group">
              <span className="text-white font-medium">Engleză (EN)</span>
              <SafeIcon icon={FiExternalLink} className="text-gray-500 group-hover:text-brand-accent transition-colors" />
            </a>
          </div>
        </div>
        <div className="bg-brand-dark border border-white/5 rounded-2xl p-8">
          <h3 className="text-white font-display font-bold text-xl mb-6 flex items-center gap-3">
            <SafeIcon icon={FiShoppingCart} className="text-brand-accent" /> Cumpără Cartea
          </h3>
          <div className="space-y-3">
            {[
              { label: "Ediție Kindle", href: bookInfoRo.links.amazon.kindle },
              { label: "Broșată", href: bookInfoRo.links.amazon.paperback },
              { label: "Cartonată", href: bookInfoRo.links.amazon.hardcover },
            ].map(({ label, href }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer"
                className="flex items-center justify-between p-4 bg-brand-accent/5 hover:bg-brand-accent/10 rounded-xl border border-brand-accent/10 transition-colors group">
                <span className="text-white font-medium">{label}</span>
                <SafeIcon icon={FiExternalLink} className="text-brand-accent/50 group-hover:text-brand-accent transition-colors" />
              </a>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default AuthorLinksRo;